export const IS_DEV =
  process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'development'

export const API_VERSION = 'v1'

export const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL
export const DOMAIN_URL_LENGTH = process.env.REACT_APP_DOMAIN_URL_LENGTH
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL
export const SERVER_URL = process.env.REACT_APP_SERVER_URL

export const ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.naivy.plam'
export const IOS_STORE_URL =
  'https://apps.apple.com/kr/app/%ED%94%8C%EB%9E%A8-%EB%A6%AC%EC%9B%8C%EB%93%9C-%EC%9D%8C%EA%B0%90%ED%9A%8C-plam/id6446476110'
// 'https://apps.apple.com/us/app/%ED%94%8C%EB%9E%A8-plam-in/id6446476110'

export const COMMENT_REPORT_REASON = {
  ko: [
    { value: '영리 목적/홍보성', label: '영리 목적/홍보성' },
    { value: '음란성/선정성', label: '음란성/선정성' },
    { value: '욕설/인신공격', label: '욕설/인신공격' },
    { value: '개인정보노출', label: '개인정보노출' },
    {
      value: '같은 내용 반복 게시 (도배)',
      label: '같은 내용 반복 게시 (도배)',
    },
    { value: '기타', label: '기타' },
  ],
  en: [
    { value: 'Profit/Advertising', label: 'Profit/Advertising' },
    { value: 'Obscene/Abusive', label: 'Obscene/Abusive' },
    { value: 'Insult/Abuse', label: 'Insult/Abuse' },
    {
      value: 'Personal information disclosure',
      label: 'Personal information disclosure',
    },
    {
      value: 'Same content repeated posting (Spam)',
      label: 'Same content repeated posting (Spam)',
    },
    { value: 'Other', label: 'Other' },
  ],
  vi: [
    {
      value: 'Mục đích lợi nhuận/Quảng cáo',
      label: 'Mục đích lợi nhuận/Quảng cáo',
    },
    { value: 'Khiêu dâm/Lạm dụng', label: 'Khiêu dâm/Lạm dụng' },
    { value: 'Xúc phạm/Lăng mạ', label: 'Xúc phạm/Lăng mạ' },
    {
      value: 'Tiết lộ thông tin cá nhân',
      label: 'Tiết lộ thông tin cá nhân',
    },
    {
      value: 'Đăng lặp lại cùng một nội dung (Spam)',
      label: 'Đăng lặp lại cùng một nội dung (Spam)',
    },
    { value: 'Khác', label: 'Khác' },
  ],
}

export const ItemTypes = {
  FILEITEM: 'fileItem',
}

export const BANNER_TYPE = {
  HOME_REWARD_BANNER: 'HOME_REWARD_BANNER',
  HOME_QUIZ_BANNER: 'HOME_QUIZ_BANNER',
  HOME_EVENT_BANNER: 'HOME_EVENT_BANNER',
  EVENT_BANNER: 'EVENT_BANNER',
  TOP_BANNER: 'TOP_BANNER',
}

export const SUPPORTED_LANGUAGES = ['ko', 'en', 'vi']

export const ARTIST_PAGE_TEXT = {
  ko: {
    tab_track: '트랙',
    tab_album: '앨범',
    tab_video: '영상',
    filter_all: '전체',
    filter_release: '발매',
    filter_feature: '참여',
    order_popular: '인기순',
    order_recent: '최신순',
    no_released_song: '발매한 곡이 없습니다.',
    no_featured_song: '참여한 곡이 없습니다.',
    no_released_album: '발매한 앨범이 없습니다.',
    no_featured_album: '참여한 앨범이 없습니다.',
    no_video: '동영상이 없습니다.',
    video_views: '조회수',
    video_like: '좋아요',
  },
  en: {
    tab_track: 'Tracks',
    tab_album: 'Albums',
    tab_video: 'Videos',
    filter_all: 'All',
    filter_release: 'Released',
    filter_feature: 'Featured',
    order_popular: 'Popular',
    order_recent: 'Latest',
    no_released_song: 'There are no released songs.',
    no_featured_song: 'There are no featured songs.',
    no_released_album: 'There are no released albums.',
    no_featured_album: 'There are no featured albums.',
    no_video: 'There are no videos.',
    video_views: 'views',
    video_like: 'likes',
  },
  vi: {
    tab_track: 'Bài hát',
    tab_album: 'Album',
    tab_video: 'Video',
    filter_all: 'Tất cả',
    filter_release: 'Đã phát hành',
    filter_feature: 'Đã tham gia',
    order_popular: 'Popular',
    order_recent: 'Latest',
    no_released_song: 'There are no released songs.',
    no_featured_song: 'There are no featured songs.',
    no_released_album: 'There are no released albums.',
    no_featured_album: 'There are no featured albums.',
    no_video: 'There are no videos.',
    video_views: 'views',
    video_like: 'likes',
  },
}

export const TRACK_PAGE_TEXT = {
  ko: {
    lyrics: '가사',
    credit: 'Credit',
    lyrics_by: '작사',
    composed_by: '작곡',
    arranged_by: '편곡',
    genre: '장르',
    more: '더보기',
    no_lyrics: '등록된 가사가 없습니다.',
    no_info: '등록된 정보가 없습니다.',
  },
  en: {
    lyrics: 'Lyrics',
    credit: 'Credit',
    lyrics_by: 'Lyrics by',
    composed_by: 'Composed by',
    arranged_by: 'Arranged by',
    genre: 'Genre',
    more: 'more',
    no_lyrics: 'There are no registered lyrics.',
    no_info: 'There is no data.',
  },
  vi: {
    lyrics: 'Lyrics',
    credit: 'Credit',
    lyrics_by: 'Lyrics by',
    composed_by: 'Composed by',
    arranged_by: 'Arranged by',
    genre: 'Genre',
    more: 'more',
    no_lyrics: 'There are no registered lyrics.',
    no_info: 'There is no data.',
  },
}

export const ALBUM_PAGE_TEXT = {
  ko: {
    tab_track_list: '수록곡',
    tab_details: '상세정보',
    type: '유형',
    genre: '장르',
    release_date: '발매일',
    distributor: '유통사',
    rights_company: '권리사',
    album_description: '앨범소개',
  },
  en: {
    tab_track_list: 'Tracklist',
    tab_details: 'Details',
    type: 'Type',
    genre: 'Genre',
    release_date: 'Release Date',
    distributor: 'Distributors',
    rights_company: 'Rights Holders',
    album_description: 'Album Description',
  },
  vi: {
    tab_track_list: 'Tracklist',
    tab_details: 'Details',
    type: 'Type',
    genre: 'Genre',
    release_date: 'Release Date',
    distributor: 'Distributors',
    rights_company: 'Rights Holders',
    album_description: 'Album Description',
  },
}

export const TRACK_RECORD_PLATFORM = {
  melon: 'melon',
  melondeeplink: 'melondeeplink',
  genie: 'genie',
  bugs: 'bugs',
  flo: 'flo',
  vibe: 'vibe',
  youtubemusic: 'youtubemusic',
  applemusic: 'applemusic',
  spotify: 'spotify',
  amazonmusic: 'amazonmusic',
  tidal: 'tidal',
  deezer: 'deezer',
  joox: 'joox',
  mymusic: 'mymusic',
  kkbox: 'kkbox',
  linejp: 'linejp',
  linetw: 'linetw',
  yandex: 'yandex',
  nct: 'nct',
  zing: 'zing',
  anghmi: 'anghmi',
  etc: 'etc',
}

export const TRACK_RECORD_ACTION = {
  YOUTUBE_PLAY: 'YOUTUBE_PLAY',
  STREAMING_REDIRECT: 'STREAMING_REDIRECT',
}

export const FANSPOT_PAGE_TEXT = {
  ko: {
    tab_hotspot: '핫스팟',
    tab_fanspot: '팬스팟',
    tab_notice: '공지사항',
    sort_latest: '최신',
    sort_popular: '인기',
    sort_views: '조회순',
    search_placeholder: '게시글 검색',
  },
  en: {
    tab_hotspot: 'Hot Spot',
    tab_fanspot: 'Fan Spot',
    tab_notice: 'Notice',
    sort_latest: 'Latest',
    sort_popular: 'Popular',
    sort_views: 'Views',
    search_placeholder: 'Search posts',
  },
  vi: {
    tab_hotspot: 'Hot',
    tab_fanspot: 'Fan spot',
    tab_notice: 'Thông báo',
    sort_latest: 'Mới nhất',
    sort_popular: 'Phổ biến nhất',
    sort_views: 'Xem nhiều nhất',
    search_placeholder: 'Tìm kiếm bài viết',
  },
}

export const ARTIST_FANSPOT_TEXT = {
  ko: {
    free_spot: '팬스팟',
    popular_posts: '인기 글',
    new_music_release: '새 음악 발매',
    fanspot_score: '팬스팟 점수',
    my_score: '나의 점수',
    search_post: '게시글 검색',
  },
  en: {
    free_spot: 'Fan Spot',
    popular_posts: 'Popular Posts',
    new_music_release: 'New Music Release',
    fanspot_score: 'Fanspot Score',
    my_score: 'My Score',
    search_post: 'Search Posts',
  },
  vi: {
    free_spot: 'Fan Spot',
    popular_posts: 'Bài viết phổ biến',
    new_music_release: 'Phát hành nhạc mới',
    fanspot_score: 'Điểm Fan Spot',
    my_score: 'Điểm của tôi',
    search_post: 'Tìm kiếm bài viết',
  },
}

export const INPLAM_ADD_PAGE_TEXT = {
  ko: {
    free_spot: '팬스팟',
    title: '글쓰기',
    cancel: '취소',
    submit: '등록',
    update: '수정',
    update_cancel_message:
      '수정 중인 글이 취소되며,\n 수정된 내용은 저장되지 않습니다',
    write_cancel_message:
      '작성 중인 글이 취소되며,\n 작성된 글은 저장되지 않습니다',
    member_required: '팬스팟 멤버가 되어야 글을 등록할 수 있습니다',
    member_register: '멤버 등록',
    open_artist_required: '팬스팟이 오픈된 아티스트만 글을 작성할 수 있습니다',
    image_limit: '한 게시글 당 이미지 첨부는 9장까지 가능합니다',
    not_enough_points: '보유 포인트가 부족합니다',
    title_placeholder: '제목을 입력하세요',
    content_placeholder: '내용을 입력하세요',
    anonymous: '익명',
    fanspot_title: '팬스팟',
    fanspot_description: '나의 소중한 아티스트와 소통하는 공간, 팬스팟',
    point_notice_1:
      '새로운 글을 작성에는 팬스팟 커뮤니티에 10포인트 이상의 기여가 필요하며, 적립된 포인트는 아티스트 및 개인 팬스팟 스코어에 적용됩니다.',
    point_notice_2:
      '팬스팟 게시글에서 다른 팬스팟 유저의 좋아요 및 댓글을 1포인트가 글쓴이 및 팬스팟 스코어에 적립되며 한 게시물에서 유저 당 1회에 한 합니다.',
    point_notice_3:
      '포인트는 일일 출석체크 등 앱 내 포인트 적립 이벤트를 통하여 추가로 적립 받으실 수 있습니다.',
    point_notice_4:
      '팬스팟 커뮤니티에서 다수의 신고 및 불법 행위가 발견되어 게시글이 삭제될 시 해당 게시물로 적립된 팬스팟 포인트는 소멸될 수 있습니다.',
  },
  en: {
    free_spot: 'Fan Spot',
    title: 'Write Post',
    cancel: 'Cancel',
    submit: 'Submit',
    update: 'Update',
    update_cancel_message:
      'The post being edited will be canceled,\n and changes will not be saved',
    write_cancel_message:
      'The post being written will be canceled,\n and content will not be saved',
    member_required: 'You need to be a fanspot member to post',
    member_register: 'Register',
    open_artist_required:
      'You can only write posts for artists with open fanspots',
    image_limit: 'You can attach up to 9 images per post',
    not_enough_points: 'Not enough points',
    title_placeholder: 'Enter title',
    content_placeholder: 'Enter content',
    anonymous: 'Anonymous',
    fanspot_title: 'Fanspot',
    fanspot_description:
      'Fanspot, a space to communicate with your favourite artist',
    point_notice_1:
      'Writing a new post requires at least 10 points contribution to the fanspot community, and accumulated points will be applied to artist and whole fanspot.',
    point_notice_2:
      'In fanspot posts, 1 point is accumulated for likes and comments from other fanspot users, limited to once per user per post.',
    point_notice_3:
      'Additional points can be earned through in-app point events such as daily check-ins.',
    point_notice_4:
      'If a post is deleted due to multiple reports or illegal activities in the fanspot community, the fanspot points earned from that post may be forfeited.',
  },
  vi: {
    write_cancel_message:
      'Nếu hủy bài viết đang thực hiện, \nnội dung sẽ không được lưu.',
    member_required:
      'Bạn phải là thành viên trong Fan Spot để có thể đăng bài.',
    member_register: 'Đăng ký thành viên',
    open_artist_required:
      'Bạn chỉ có thể viết bài cho nghệ sĩ khi Fan Spot được mở rộng.',
    image_limit: 'Bạn có thể đính kèm tối đa 9 ảnh cho mỗi bài viết',
    not_enough_points: 'Số điểm hiện tại đang không đủ để thực hiện.',
    title_placeholder: 'Nhập tiêu đề',
    content_placeholder: 'Nhập nội dung',
    anonymous: 'Người dùng ẩn danh',
    fanspot_title: 'Fan Spot',
    fanspot_description:
      'Fan Spot, không gian giao lưu với nghệ sĩ mà bạn yêu thích.',
    point_notice_1:
      'Bạn cần có ít nhất 10 điểm để viết bài trên Fan Spot, điểm này sẽ được tích lũy cho riêng nghệ sĩ và điểm chung Fan Spot của nghệ sĩ.',
    point_notice_2:
      'Mỗi lượt thích/bình luận vào bài viết của thành viên khác trong Fan Spot sẽ được tích lũy 1 điểm. Mỗi bài viết chỉ được duy nhất 1 lần thích và 1 lần bình luận.',
    point_notice_3:
      'Có thể tích lũy điểm mỗi ngày thông qua Daily Check-in hoặc các event khác của Plam.',
    point_notice_4:
      'Nếu có bài viết/ bình luận bị báo cáo hoặc có hoạt động bất hợp pháp trong cộng đồng Fan Spot, thì điểm có được từ bài viết/ bình luận đó có thể bị mất.',
    free_spot: 'Fan Spot',
    title: 'Viết bài',
    cancel: 'Hủy',
    submit: 'Đăng',
    update: 'Cập nhật',
    update_cancel_message:
      'Nếu hủy bài viết đang chỉnh sửa\\n và các thay đổi sẽ không được lưu',
  },
}

export const SEARCH_PAGE_TEXT = {
  ko: {
    search_placeholder: '통합 검색',
    search_button_alt: '검색',
    clear_button_alt: '지우기',
    searching: '검색중..',
    no_results: '검색 결과가 없습니다.',
    see_more: '더보기',
    filter_all: '전체',
    filter_fanspot: '팬스팟',
    filter_artist: '아티스트',
    filter_track: '트랙',
    filter_album: '앨범',
    not_open: '오픈 전',
    from_artist: '아티스트로부터',
    has_image: '이미지 있음',
  },
  en: {
    search_placeholder: 'Search',
    search_button_alt: 'Search',
    clear_button_alt: 'Clear',
    searching: 'Searching...',
    no_results: 'No search results',
    see_more: 'See more',
    filter_all: 'All',
    filter_fanspot: 'Fanspot',
    filter_artist: 'Artists',
    filter_track: 'Tracks',
    filter_album: 'Albums',
    not_open: 'Not open yet',
    from_artist: 'From artist',
    has_image: 'Has image',
  },
  vi: {
    search_placeholder: 'Tìm kiếm tổng hợp',
    search_button_alt: 'Tìm kiếm',
    clear_button_alt: 'Xóa',
    searching: 'Đang tìm kiếm...',
    no_results: 'Không có kết quả tìm kiếm.',
    see_more: 'Xem thêm',
    filter_all: 'Tất cả',
    filter_fanspot: 'Fan Spot',
    filter_artist: 'Nghệ sĩ',
    filter_track: 'Tracks',
    filter_album: 'Albums',
    not_open: 'Đang chuẩn bị',
    from_artist: 'Từ nghệ sĩ',
    has_image: 'Có hình ảnh',
  },
}

export const POPUP_TEXT = {
  ko: {
    link_copied: '링크가 복사되었습니다.',
    referral_code_copied: '추천 코드가 복사되었습니다.',
    ok_text: '확인',
    cancel_text: '취소',
  },
  en: {
    link_copied: 'Link has been copied.',
    referral_code_copied: 'Referral code has been copied.',
    ok_text: 'OK',
    cancel_text: 'Cancel',
  },
  vi: {
    link_copied: 'Đã sao chép liên kết.',
    referral_code_copied: 'Đã sao chép mã giới thiệu.',
    ok_text: 'Chặn',
    cancel_text: 'Hủy',
  },
}

export const BURGER_MENU_TEXT = {
  ko: {
    login_please: '로그인을 해주세요',
    current_points: '보유 포인트',
    my_referral_code: '내 추천 코드',
    commented_posts: '댓글 단 글',
    written_posts: '작성한 글',
    comment_notification: '댓글 알림',
    reply_notification: '답글 알림',
    no_written_posts: '작성한 글이 없습니다',
    no_commented_posts: '댓글 단 글이 없습니다',
    ad_inquiry: '광고 문의',
    customer_service: '고객센터',
    terms_of_use: '이용약관',
    privacy_policy: '개인정보처리방침',
    logout: '로그아웃',
    withdraw: '회원탈퇴',
    share: '공유하기',
    home: '홈',
    change_language: '서비스 언어 변경',
    my_fanspot: '나의 팬스팟',
    referral_code_label: '추천 코드',
    referral_code_description:
      '*내 추천인 코드를 신규 회원이 입력하고 플레이 음감회에 참여 시\n1,000 포인트가 적립됩니다.',
    share_text:
      '[플램 - 플레이 음감회, PLAM]\n음악을 감상하면 돈이 벌리는 음악 앱테크 리워드 서비스, 플레이 음감회로 여러분을 초대합니다.\n지금 다운로드 받고, 새로운 음악을 발견하며 돈도 벌어보세요.\n플레이 음감회 앱(https://plam.in/download)\n추천인 코드: {referralCode}',
    app_install_title: '앱 설치하고',
    app_install_title_highlight: '쉽고 편리하게!',
    app_install_description: '플램 서비스를 활용 해보세요.',
    app_download: '앱 다운로드',
    favorite_limit_title: '즐겨찾는 팬스팟은 5개까지 추가 가능합니다',
    // 알림
    notification: '알림',
    notification_empty: '알림이 없습니다',
    notification_new_album: '새 음악 발매',
    notification_melon_rise: '멜론 음악 상승',
    notification_fanspot: '팬스팟',

    time_minutes_ago: '{minutes}분 전',
    time_hours_ago: '{hours}시간 전',
    time_days_ago: '{days}일 전',
  },
  en: {
    login_please: 'Please login',
    current_points: 'Current points',
    my_referral_code: 'My referral code',
    commented_posts: 'My comments',
    written_posts: 'Written posts',
    comment_notification: 'Comments alarm',
    reply_notification: 'Reply alarm',
    no_written_posts: 'No written posts yet',
    no_commented_posts: 'No commented yet',
    ad_inquiry: 'Advertising request',
    customer_service: 'Customer Service Center',
    terms_of_use: 'Terms of Use',
    privacy_policy: 'Privacy Policy',
    logout: 'Logout',
    withdraw: 'Delete account',
    share: 'Share',
    home: 'Home',
    change_language: 'Change language',
    my_fanspot: 'My Fanspot',
    referral_code_label: 'Referral Code',
    referral_code_description:
      '*When a new member enters my referral code and participates in Play Music Review,\n1,000 points will be credited.',
    share_text:
      '[PLAM - Play Music Review]\nWe invite you to Play Music Review, a music app-tech reward service where you can earn money by listening to music.\nDownload now and discover new music while earning money.\nPlay Music Review App(https://plam.in/download)\nReferral Code: {referralCode}',
    app_install_title: 'Download Plam App',
    app_install_title_highlight: 'for more convenient use!',
    app_install_description: 'Try out the Plam service.',
    app_download: 'Download App',
    favorite_limit_title: 'You can add up to 5 favourite fanspots',
    notification: 'Notification',
    notification_empty: 'Notification is empty',
    notification_new_album: 'New Abum Release',
    notification_melon_rise: 'Melon Music Chart',
    notification_fanspot: 'Fanspot',
    time_minutes_ago: '{minutes}m ago',
    time_hours_ago: '{hours}h ago',
    time_days_ago: '{days}d ago',
  },
  vi: {
    reply_notification: 'Thông báo trả lời bình luận',
    no_written_posts: 'Chưa có bài viết hiển thị',
    no_commented_posts: 'Chưa có bình luận hiển thị',
    ad_inquiry: 'Yêu cầu dịch vụ quảng cáo',
    customer_service: 'Trung tâm CHSK',
    terms_of_use: 'Điều khoản sử dụng',
    privacy_policy: 'Chính sách bảo mật',
    logout: 'Đăng xuất',
    withdraw: 'Xóa tài khoản',
    share: 'Chia sẻ',
    home: 'Trang chủ',
    change_language: 'Thay đổi ngôn ngữ',
    my_fanspot: 'Fan Spot của tôi',
    referral_code_label: 'Mã giới thiệu',
    referral_code_description:
      '*Khi thành viên mới nhập mã giới thiệu của tôi và tham gia Play Music Review,\nsẽ được cộng 1.000 điểm tích lũy.',
    share_text:
      '[PLAM - Play Music Review]\nChúng tôi mời bạn tham gia Play Music Review, vừa có thu nhập vừa có thể thưởng thức âm nhạc.  \nTải ngay để có thể kiếm tiền với việc khám phá những bài hát mới. \nỨng dụng Play Music Review(https://plam.in/download)\nMã giới thiệu: {referralCode}',
    login_please: 'Vui lòng đăng nhập',
    current_points: 'Điểm hiện đang có ',
    my_referral_code: 'Mã giới thiệu của tôi',
    commented_posts: 'Bài viết đã bình luận',
    written_posts: 'Bài viết của tôi',
    comment_notification: 'Thông báo bình luận',
    app_install_title: 'Cài đặt ứng dụng để',
    app_install_title_highlight: 'sử dụng dễ dàng!',
    app_install_description: 'Hãy thử sử dụng dịch vụ của Plam.',
    app_download: 'Tải ứng dụng',
    favorite_limit_title: 'Bạn có thể thêm tối đa 5 Fan Spot yêu thích',
    notification: 'Thông báo',
    notification_empty: 'Không có thông báo mới',
    notification_new_album: 'Phát hành album mới',
    notification_melon_rise: 'Bảng xếp hạng âm nhạc Melon',
    notification_fanspot: 'Fan Spot',
    time_minutes_ago: '{minutes} phút trước',
    time_hours_ago: '{hours} giờ trước',
    time_days_ago: '{days} ngày trước',
  },
}

export const FANSPOT_ARTICLE_PAGE_TEXT = {
  ko: {
    notice_title: '공지사항',
    meta_description: '소중한 나의 아티스트와 소통하는 공간, 팬스팟',
    list_button: '목록',
    delete_title: '내 게시글 삭제',
    delete_button: '삭제',
    plam_name: '플램 PLAM',
    anonymous: '익명',
    report_complete: '신고처리가 완료되었습니다',
    block_complete: '사용자 차단이 완료되었습니다',
    already_reported: '이미 신고한 댓글입니다',
    block_failed: '차단에 실패하였습니다',
    view_count: '조회',
    report_title: '신고하기',
    report_reason: '신고사유',
    report_other_placeholder: '기타 항목 선택 후 입력해주세요',
    cancel_button: '취소',
    report_button: '신고',
    block_message: '이 회원의 게시글, 댓글이 보이지 않습니다.\n차단하시겠어요?',
    block_button: '차단',
    favorite_message: '아티스트 팬스팟 멤버만 가능합니다.',
    confirm_button: '확인',
    member_register_button: '멤버등록',
    share_link: '링크 공유',
    edit_button: '수정',
    next_article: '다음 글',
    fanspot_suffix: '팬스팟',
    // 댓글 관련 텍스트
    comment_count: '댓글 %s',
    comment_login_required: '로그인을 해주세요',
    comment_like_required: '좋아요를 눌러주세요',
    comment_placeholder: '댓글을 입력해주세요.',
    comment_anonymous: '익명',
    comment_submit: '등록',
    comment_empty: '댓글이 없습니다',
    comment_empty_description: '첫번째 댓글을 남겨주세요',
    comment_more: '더보기',
    comment_writer: '글쓴이',
    comment_update: '수정',
    comment_delete: '삭제',
    comment_block: '차단',
    comment_report: '신고',
    comment_deleted: '삭제된 댓글입니다',
    comment_hidden: '비공개된 댓글입니다',
    comment_cancel: '취소',
    comment_update_complete: '수정완료',
    comment_reply: '답글',
    comment_reply_count: '답글 %s개',
    comment_reply_write: '답글 달기',
    // 팝업 관련 텍스트
    popup_like_artist: '아티스트 좋아요를 눌러주세요',
    popup_like_button: '좋아요',
    popup_delete_comment: '댓글을 삭제합니다',
    popup_self_like_error: '내 댓글에는 좋아요를 누를 수 없습니다',
  },
  en: {
    notice_title: 'Notifications',
    meta_description:
      'Fan Spot a space to communicate with my favourite artist',
    list_button: 'List',
    delete_title: 'Delete post',
    delete_button: 'Delete',
    plam_name: 'PLAM',
    anonymous: 'Anonymous',
    report_complete: 'Report has been completed',
    block_complete: 'User blocking has been completed',
    already_reported: 'This comment has been reported',
    block_failed: 'Blocking failed',
    view_count: 'Views',
    report_title: 'Report',
    report_reason: 'Report reason',
    report_other_placeholder: 'Please select "Other" and enter details',
    cancel_button: 'Cancel',
    report_button: 'Report',
    block_message:
      'Posts and comments from this user will not be visible.\nDo you want to block?',
    block_button: 'Block',
    favorite_message: 'Only available for artist fan spot members.',
    confirm_button: 'Confirm',
    member_register_button: 'Register',
    share_link: 'Share link',
    edit_button: 'Edit',
    next_article: 'Next post',
    fanspot_suffix: 'Fan Spot',
    comment_count: 'Comments %s',
    comment_login_required: 'Please log in',
    comment_like_required: 'Please like first',
    comment_placeholder: 'Write a comment...',
    comment_anonymous: 'Anonymous',
    comment_submit: 'Post',
    comment_empty: 'No comments yet',
    comment_empty_description: 'Be the first to leave a comment',
    comment_more: 'Show more',
    comment_writer: 'Author',
    comment_update: 'Edit',
    comment_delete: 'Delete',
    comment_block: 'Block',
    comment_report: 'Report',
    comment_deleted: 'Comment deleted',
    comment_hidden: 'Closed comment',
    comment_cancel: 'Cancel',
    comment_update_complete: 'Edit complete',
    comment_reply: 'Reply',
    comment_reply_count: 'Replies %s',
    comment_reply_write: 'Write a reply comment',
    popup_like_artist: 'Please like the artist first',
    popup_like_button: 'Like',
    popup_delete_comment: 'Delete this comment',
    popup_self_like_error: 'You cannot like your own comment',
  },
  vi: {
    anonymous: 'Người dùng ẩn danh',
    report_complete: 'Đã báo cáo',
    block_complete: 'Đã chặn người dùng này',
    already_reported: 'Đã báo cáo bình luận này',
    block_failed: 'Chặn thất bại',
    view_count: 'Lượt xem',
    report_other_placeholder: 'Vui lòng chọn Khác và nhập chi tiết',
    block_message:
      'Ẩn các bài viết, bình luận của thành viên này.\nBạn có muốn chặn không?',
    favorite_message:
      'Chỉ dành cho thành viên đã tham gia Fan Spot của nghệ sĩ',
    member_register_button: 'Đăng ký thành viên',
    comment_hidden: 'Đã ẩn bình luận này',
    comment_reply_count: 'Số câu trả lời %s',
    comment_reply_write: 'Viết câu trả lời',
    notice_title: 'Thông báo',
    meta_description: 'Không gian giao tiếp với nghệ sĩ yêu thích ',
    list_button: 'Mục lục',
    delete_title: 'Xóa bài viết của tôi',
    delete_button: 'Xóa',
    plam_name: 'PLAM',
    report_title: 'Báo cáo',
    report_reason: 'Lý do báo cáo',
    cancel_button: 'Hủy bỏ',
    share_link: 'Chia sẻ liên kết',
    edit_button: 'Chỉnh sửa',
    next_article: 'Xem thêm bài viết',
    fanspot_suffix: 'Fan Spot',
    report_button: 'Báo cáo',
    block_button: 'Chặn',
    confirm_button: 'Xác nhận',
    comment_count: 'Bình luận %s',
    comment_login_required: 'Vui lòng đăng nhập',
    comment_like_required: 'Vui lòng nhấn yêu thích trước ',
    comment_placeholder: 'Nhập bình luận tại đây',
    comment_anonymous: 'Người dùng giấu tên',
    comment_submit: 'Đăng',
    comment_empty: 'Hiện tại chưa có bình luận nào',
    comment_empty_description: 'Hãy nhập bình luận đầu tiên.',
    comment_more: 'Xem thêm',
    comment_writer: 'Tác giả',
    comment_update: 'Chỉnh sửa',
    comment_delete: 'Xóa',
    comment_block: 'Chặn',
    comment_report: 'Báo cáo',
    comment_deleted: 'Bình luận đã bị xóa',
    comment_cancel: 'Hủy',
    comment_update_complete: 'Cập nhật hoàn tất',
    comment_reply: 'Trả lời',
    popup_like_artist: 'Vui lòng chọn nghệ sĩ bạn yêu thích ',
    popup_like_button: 'Thích',
    popup_delete_comment: 'Xóa bình luận này',
    popup_self_like_error: 'Bạn không thể thích bình luận của chính mình',
  },
}

export const EDIT_PROFILE_TEXT = {
  ko: {
    profile_edit: '프로필 수정',
    complete: '완료',
    modify: '수정',
    file_size_limit: '파일 용량은 50MB까지 가능합니다.',
    nickname_exists: '이미 존재하는 닉네임입니다',
    nickname_rule: '최대 8글자의 한글, 영문자, 숫자만 입력 가능합니다',
  },
  en: {
    profile_edit: 'Account settings',
    complete: 'Done',
    modify: 'Save',
    file_size_limit: 'File size is limited to 50MB.',
    nickname_exists: 'This nickname already exists',
    nickname_rule: 'Maximum 8 characters of Korean, English, and numbers only',
  },
  vi: {
    profile_edit: 'Chỉnh sửa thông tin cá nhân',
    complete: 'Hoàn tất',
    modify: 'Lưu chỉnh sửa',
    file_size_limit: 'Kích thước tệp giới hạn đến 50MB.',
    nickname_exists: 'Biệt danh này đã tồn tại',
    nickname_rule: 'Tối đa 8 ký tự bao gồm tiếng Hàn, tiếng Anh và số',
  },
}
